import { getConfig } from '@/utils/config/config';
import { COUNTRY, ENVIRONMENT, REGIONS } from '@/utils/constants';
import { COOKIES, getCookieValue } from '@/utils/cookies';
import { fetchApi } from './fetcher';

export const getTransactionHistory = async (params: { pathname: string; search: string }) => {
    const config = getConfig();
    const region = await getCookieValue(COOKIES.REGION);
    const authToken = await getCookieValue(COOKIES.AUTH_TOKEN);
    const loginToken = await getCookieValue(COOKIES.LOGIN_TOKEN);

    const defaultRegion = process.env.COUNTRY === COUNTRY.CANADA ? REGIONS.ON : REGIONS.PA;
    const resolvedRegion = process.env.CONFIG_ENV === ENVIRONMENT.mockHarness ? region || defaultRegion : region;
    const thBaseUrl =
        config?.apis?.TransactionHistory?.baseUrl?.replace('statePlaceholder', resolvedRegion.toLowerCase()) ||
        config?.apis?.TransactionHistory?.baseUrl?.replace('statePlaceholder', defaultRegion.toLowerCase());

    const networkConfig = config?.network?.InternalTransactionHistory;

    const response = await fetchApi(
        `${thBaseUrl}/api/game-transaction-history`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                [COOKIES.AUTH_TOKEN]: authToken,
                [COOKIES.LOGIN_TOKEN]: loginToken
            },
            credentials: 'omit',
            body: JSON.stringify(params)
        },
        networkConfig ? { networkConfig } : undefined
    );

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    return response.json();
};
